import styled, { css } from 'styled-components';

import { Box } from '@/components/Box';
import { Flex } from '@/components/Flex';
import { Typography } from '@/components/Typography';
import type { Maybe } from '@/lib/types';

import { ReactComponent as InfoBadge } from '@/assets/icons/info-badge.svg';

export const Wrapper = styled(Flex)`
  flex-direction: column;
  align-items: center;
  max-width: 100px;
  width: 100%;
  margin: 0 auto;
  ${({ theme }) => css`
    ${theme.media.sm.up} {
      width: fit-content;
      max-width: inherit;
    }
  `}
`;

export const Name = styled(Typography)`
  text-align: center;
  white-space: nowrap;

  ${({ theme }) => css`
    font-size: ${theme.fontSizes.p3};
    color: ${theme.colors.secondaryGrey};
    margin-top: ${theme.spacing(1)};

    ${theme.mediaQueries.md} {
      font-size: ${theme.fontSizes.p1};
    }
  `}
`;

export const Value = styled(Typography)`
  word-break: break-word;
  text-align: center;
  text-transform: lowercase;
  display: inline;

  &::first-letter {
    text-transform: capitalize;
  }

  ${({ theme }) => css`
    font-weight: ${theme.fontWeights.bold};
    font-size: ${theme.fontSizes.p3};

    ${theme.mediaQueries.md} {
      font-size: ${theme.fontSizes.p2};
    }
  `}
`;
export const ValueBox = styled(Box)`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const InfoBadgeIcon = styled(InfoBadge)`
  width: 12px;
  height: 13px;
  margin-left: 5px;
  &:hover {
    cursor: pointer;
  }
`;

export const ColorFeature = styled(Flex)`
  width: 70px;
  height: 70px;
  border-radius: 50%;
  justify-content: center;
  align-items: center;
  ${({ theme }) => css`
    background-color: ${theme.colors.mediumGrey};
  `}
`;

export const ColorCircle = styled(Box)<{ $color?: Maybe<string> }>`
  width: 35px;
  height: 35px;
  border-radius: 50%;
  ${({ $color, theme }) => css`
    background-color: ${$color || theme.colors.black};
  `}
`;
